import { CentralNotificacaoDiaSemana } from "./central-notificacao-dia-semana.model";
import { CentralNotificacaoPerfil } from "./central-notificacao-perfil.model";
import { CentralNotificacaoSistema } from "./central-notificacao-sistema.model";
import { CentralNotificacaoMensalDia } from "./central-notificacao-mensal-dia.model";
import { CentralNotificacaoMensalMes } from "./central-notificacao-mensal-mes.model";


export class CentralNotificacao{
    public id: number;
    public descricao: string;
    public tipo_rotina: number;
    public horario: Date;
    public data_especifica: Date;
    public id_situacao: number;
    public cpf: string;
    public url: string;

    public central_notificacao_dia_semana: CentralNotificacaoDiaSemana[] = [];
    public central_notificacao_mensal_dia: CentralNotificacaoMensalDia[] = [];
    public central_notificacao_mensal_mes: CentralNotificacaoMensalMes[] = [];
    public central_notificacao_perfil: CentralNotificacaoPerfil[] = [];
    public central_notificacao_sistema: CentralNotificacaoSistema[] = [];


    public constructor(dados: any, listaDiaSemana: any[], listaMes: any[], listaDiasMes: any[], listaPerfil: any[], listaSistema: any[]){
        this.id = dados.id;
        this.descricao = dados.descricao;
        this.tipo_rotina = dados.tipo_rotina;
        this.horario = dados.horario;
        this.data_especifica = dados.data_especifica;
        this.id_situacao = dados.id_situacao;
        this.cpf = dados.cpf;
        this.url = dados.url;

        if(listaDiaSemana.length > 0){
            listaDiaSemana.map(x => {
                this.central_notificacao_dia_semana.push(new CentralNotificacaoDiaSemana(x, dados.id));
            });
        }

        if(listaPerfil){
            listaPerfil.map(x => {
                this.central_notificacao_perfil.push(new CentralNotificacaoPerfil(x, dados.id));
            });
        }

        if(listaSistema.length > 0){
            listaSistema.map(x => {
                this.central_notificacao_sistema.push(new CentralNotificacaoSistema(x, dados.id));
            });
        }

        if(listaDiasMes.length > 0){
            listaDiasMes.map(x => {
                this.central_notificacao_mensal_dia.push(new CentralNotificacaoMensalDia(x, dados.id));
            });
        }
        
        if(listaMes.length > 0){
            listaMes.map(x => {
                this.central_notificacao_mensal_mes.push(new CentralNotificacaoMensalMes(x, dados.id));
            });
        }

    }
}


// WEBPACK FOOTER //
// ./src/app/entity/central-notificacao.model.ts